import { AlertCircle, Loader2, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useEffectPackCandidates } from '../api';
import { EffectPackCandidateCard } from '../components/EffectPackCandidateCard';

/**
 * Effect Pack Review / Curation queue (CMP parity: EffectPackReviewScreen.kt). A flat scrollable
 * list of candidates awaiting approve/reject, with a header pending-count + manual Reload.
 */
export function EffectPackReviewPage() {
  const { data, isLoading, isFetching, isError, error, refetch } = useEffectPackCandidates();
  const candidates = data ?? [];

  return (
    <div className="flex h-full flex-col gap-4 p-6">
      <div className="flex items-center gap-3">
        <h1 className="text-2xl font-semibold tracking-tight">Effect Pack Review</h1>
        <span className="text-sm text-muted-foreground">{candidates.length} pending</span>
        <div className="flex-1" />
        <Button variant="outline" size="sm" onClick={() => void refetch()} disabled={isFetching}>
          <RefreshCw className={isFetching ? 'size-4 animate-spin' : 'size-4'} />
          Reload
        </Button>
      </div>

      {isError && (
        <div className="flex items-center justify-between gap-3 rounded-md border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive">
          <div className="flex items-center gap-2">
            <AlertCircle className="size-4 shrink-0" />
            <span>{error instanceof Error ? error.message : 'Failed to load candidates.'}</span>
          </div>
          <Button variant="outline" size="sm" onClick={() => void refetch()}>
            Retry
          </Button>
        </div>
      )}

      {isLoading && candidates.length === 0 ? (
        <div className="flex flex-1 items-center justify-center py-24">
          <Loader2 className="size-6 animate-spin text-primary" />
        </div>
      ) : candidates.length === 0 ? (
        <div className="flex flex-1 items-center justify-center py-24 text-sm text-muted-foreground">
          No candidates to review.
        </div>
      ) : (
        <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto">
          {candidates.map((candidate, i) => (
            <EffectPackCandidateCard key={candidate.id ?? i} candidate={candidate} />
          ))}
        </div>
      )}
    </div>
  );
}
